export default __webpack_public_path__ + "static/builder-7423620b269c78d470fa60c3952b8cf1.mp4";